// src/actions/createGlobalAddress.ts
import { zeroAddress } from "viem";

// src/constants.ts
import {
  arbitrum,
  arbitrumSepolia,
  base,
  baseSepolia,
  blast,
  blastSepolia,
  mainnet,
  mode,
  optimism,
  optimismSepolia,
  polygon,
  polygonAmoy,
  scroll,
  sepolia,
  worldchain,
  zora
} from "viem/chains";
var FLEX = /* @__PURE__ */ ((FLEX2) => {
  FLEX2["TOKEN_ADDRESS"] = "TOKEN_ADDRESS";
  FLEX2["AMOUNT"] = "AMOUNT";
  FLEX2["NATIVE_AMOUNT"] = "NATIVE_AMOUNT";
  return FLEX2;
})(FLEX || {});
var AMOUNT = /* @__PURE__ */ ((AMOUNT2) => {
  AMOUNT2["MAX"] = "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
  AMOUNT2["BRIDGED"] = "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe";
  return AMOUNT2;
})(AMOUNT || {});
var GLOBAL_ADDRESS_SERVER_URL = "https://global-address-server.onrender.com";
var TOKEN_ADDRESSES = {
  [arbitrum.id]: {
    USDC: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    WRAPPED_NATIVE: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    USDT: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    WBTC: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f"
  },
  [base.id]: {
    USDC: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006",
    DAI: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb"
  },
  [blast.id]: {
    WRAPPED_NATIVE: "0x4300000000000000000000000000000000000004",
    WBTC: "0xF7bc58b8D8f97ADC129cfC4c9f45Ce3C0E1D2692"
  },
  [mainnet.id]: {
    USDC: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    WRAPPED_NATIVE: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    USDT: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    DAI: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    WBTC: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
  },
  [mode.id]: {
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006",
    USDC: "0xd988097fb8612cc24eeC14542bC03424c656005f",
    USDT: "0xf0F161fDA2712DB8b566946122a5af183995e2eD",
    WBTC: "0xcDd475325D6F564d27247D1DddBb0DAc6fA0a5CF"
  },
  [optimism.id]: {
    USDC: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006",
    USDT: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
    DAI: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
    WBTC: "0x68f180fcCe6836688e9084f035309E29Bf0A2095"
  },
  [polygon.id]: {
    USDC: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
    WRAPPED_NATIVE: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
    WETH: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
    DAI: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
    USDT: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    WBTC: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6"
  },
  [scroll.id]: {
    USDC: "0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4",
    WRAPPED_NATIVE: "0x5300000000000000000000000000000000000004",
    USDT: "0xf55BEC9cafDbE8730f096Aa55dad6D22d44099Df",
    WBTC: "0x3C1BCa5a656e69edCD0D4E36BEbb3FcDAcA60Cf1"
  },
  [zora.id]: {
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006"
  },
  [worldchain.id]: {
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006",
    USDC: "0x79A02482A880bCE3F13e09Da970dC34db4CD24d1",
    WBTC: "0x03C7054BCB39f7b2e5B2c7AcB37583e32D70Cfa3"
  },
  [sepolia.id]: {
    USDC: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
    WRAPPED_NATIVE: "0xfff9976782d46cc05630d1f6ebab18b2324d6b14"
  },
  [polygonAmoy.id]: {
    USDC: "0x41e94eb019c0762f9bfcf9fb1e58725bfb0e7582",
    WRAPPED_NATIVE: "0x52eF3d68BaB452a294342DC3e5f464d7f610f72E"
  },
  [arbitrumSepolia.id]: {
    USDC: "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d",
    WRAPPED_NATIVE: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73"
  },
  [baseSepolia.id]: {
    USDC: "0x036CbD53842c5426634e7929541eC2318f3dCF7e",
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000006"
  },
  [blastSepolia.id]: {
    USDC: "0x4200000000000000000000000000000000000022",
    WRAPPED_NATIVE: "0x4200000000000000000000000000000000000023"
  },
  [optimismSepolia.id]: {
    // USDC: "0x",
    // WRAPPED_NATIVE: "0x",
  }
};
var getWrappedNativeAddress = (chainId) => {
  const chainData = TOKEN_ADDRESSES[chainId];
  if (!chainData) {
    throw new Error(`Chain ${chainId} not supported`);
  }
  return chainData.WRAPPED_NATIVE;
};

// src/utils/index.ts
import { toHex } from "viem";
function deepHexlify(obj) {
  if (typeof obj === "function") {
    return void 0;
  }
  if (obj == null || typeof obj === "string" || typeof obj === "boolean" || typeof obj === "number") {
    return obj;
  }
  if (typeof obj === "bigint") {
    return toHex(obj);
  }
  if (obj._isBigNumber != null || typeof obj !== "object") {
    return toHex(obj).replace(/^0x0/, "0x");
  }
  if (Array.isArray(obj)) {
    return obj.map((member) => deepHexlify(member));
  }
  return Object.keys(obj).reduce((set, key) => {
    set[key] = deepHexlify(obj[key]);
    return set;
  }, {});
}

// src/actions/createGlobalAddress.ts
var CallType = /* @__PURE__ */ ((CallType2) => {
  CallType2[CallType2["CALL"] = 0] = "CALL";
  return CallType2;
})(CallType || {});
var createGlobalAddress = async ({
  destChain,
  owner,
  slippage,
  actions,
  srcTokens,
  config
}) => {
  const requestBody = {
    executionChainId: destChain.id,
    owner,
    slippage,
    srcTokens: srcTokens?.map((token) => ({
      token: token.tokenType === "NATIVE" ? zeroAddress : TOKEN_ADDRESSES[token.chain.id][token.tokenType] ?? "0xffffffffffffffffffffffffffffffffffffffff",
      chainId: token.chain.id,
      minAmount: token?.minAmount ?? 0n
    })),
    actions: Object.entries(actions).map(([tokenType, action]) => {
      const isNative = tokenType === "NATIVE";
      const asset = tokenType === "NATIVE" ? getWrappedNativeAddress(destChain.id) : TOKEN_ADDRESSES[destChain.id][tokenType] ?? "0xffffffffffffffffffffffffffffffffffffffff";
      const withdrawWethCall = isNative ? [
        {
          target: getWrappedNativeAddress(destChain.id),
          value: 0n,
          callType: 0 /* CALL */,
          // withdraw
          data: "0x2e1a7d4d0000000000000000000000000000000000000000000000000000000000000000",
          tokenAddressOffset: 0n,
          tokenAmountOffset: 4n
        }
      ] : [];
      const calls = withdrawWethCall.concat(action.action);
      const fallBack = withdrawWethCall.concat(action.fallBack);
      return {
        calls: calls.map((call) => ({
          ...call,
          actionType: call.callType
        })),
        fallBack: fallBack.map((call) => ({
          ...call,
          actionType: call.callType
        })),
        asset,
        isNative
      };
    })
  };
  const baseUrl = config?.baseUrl || GLOBAL_ADDRESS_SERVER_URL;
  const res = await fetch(`${baseUrl}/v1`, {
    method: "POST",
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 225,
      method: "ma_createMagicAddress",
      params: [deepHexlify(requestBody)]
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  if (!res.ok) {
    const data2 = await res.json();
    const errorMessage = data2?.error ?? res.statusText;
    throw new Error(`Failed to create global address ${errorMessage}`);
  }
  const data = await res.json();
  if (data.result.magicAddress) {
    const { magicAddress, ...rest } = data.result;
    return {
      globalAddress: magicAddress,
      ...rest
    };
  }
  return data.result;
};

// src/actions/getGlobalAddressFeeEstimates.ts
var getGlobalAddressFeeEstimates = async (params) => {
  const { globalAddress, config } = params;
  const requestBody = globalAddress;
  const baseUrl = config?.baseUrl || GLOBAL_ADDRESS_SERVER_URL;
  const res = await fetch(`${baseUrl}/v1`, {
    method: "POST",
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "ma_getEstimatedFeesByMagicAddress",
      params: [deepHexlify(requestBody)]
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  if (!res.ok) {
    throw new Error(`Failed to get global address fees: ${res.statusText}`);
  }
  const data = await res.json();
  if (data.error) {
    throw new Error(`Error from server: ${data.error.message}`);
  }
  const result = data.result;
  return result;
};

// src/actions/getGlobalAddressInfo.ts
var getGlobalAddressInfo = async (params) => {
  const { globalAddress, config } = params;
  const requestBody = {
    magicAddress: globalAddress
  };
  const baseUrl = config?.baseUrl || GLOBAL_ADDRESS_SERVER_URL;
  const res = await fetch(`${baseUrl}/v1`, {
    method: "POST",
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "ma_getMagicAddress",
      params: [deepHexlify(requestBody)]
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  if (!res.ok) {
    throw new Error(`Failed to get global address info: ${res.statusText}`);
  }
  const data = await res.json();
  if (data.error) {
    throw new Error(`Error from server: ${data.error.message}`);
  }
  const result = data.result;
  return result;
};

// src/actions/getGlobalAddressStatus.ts
var getGlobalAddressStatus = async (params) => {
  const { globalAddress, page = 1, pageSize = 50, config } = params;
  const requestBody = {
    magicAddress: globalAddress,
    page,
    pageSize
  };
  const baseUrl = config?.baseUrl || GLOBAL_ADDRESS_SERVER_URL;
  const res = await fetch(`${baseUrl}/v1`, {
    method: "POST",
    body: JSON.stringify({
      jsonrpc: "2.0",
      id: 1,
      method: "ma_getMagicAddressStatus",
      params: [deepHexlify(requestBody)]
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  if (!res.ok) {
    throw new Error(
      `Failed to get global address status: ${res.statusText}`
    );
  }
  const data = await res.json();
  if (data.error) {
    throw new Error(`Error from server: ${data.error.message}`);
  }
  const result = data.result;
  return result;
};

// src/utils/createCall.ts
import {
  encodeFunctionData,
  getAbiItem,
  isHex,
  zeroAddress as zeroAddress2
} from "viem";
var createCall = ({
  target,
  value,
  actionType,
  abi,
  functionName,
  args
}) => {
  let abiItem;
  let tokenAddressOffset = 0n;
  let tokenAmountOffset = 0n;
  let data = "0x";
  if (abi) {
    abiItem = getAbiItem({
      abi,
      name: functionName,
      args
    });
    if (abiItem?.type !== "function") {
      throw Error(`${functionName} not found in abi`);
    }
    const _args = Array.isArray(args) ? [...args] : [];
    const paramOffset = 4n;
    abiItem.inputs?.forEach((input, index) => {
      if (input.type.includes("int") && _args && _args[index] === "AMOUNT" /* AMOUNT */) {
        _args[index] = BigInt(0);
        tokenAmountOffset = paramOffset + BigInt(index) * BigInt(32);
      } else if (input.type.includes("address") && _args && _args[index] === "TOKEN_ADDRESS" /* TOKEN_ADDRESS */) {
        _args[index] = zeroAddress2;
        tokenAddressOffset = paramOffset + BigInt(index) * BigInt(32);
      }
    });
    data = encodeFunctionData({
      abi,
      args: _args,
      functionName
    });
  }
  if (target === "TOKEN_ADDRESS" /* TOKEN_ADDRESS */) {
    target = "0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF";
  }
  if (value === "NATIVE_AMOUNT" /* NATIVE_AMOUNT */) {
    value = BigInt(
      "0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfFfffffFfFFFffffFfFfFfffff"
    );
  }
  return {
    target,
    value: isHex(value) ? BigInt(value) : value ?? BigInt(0),
    callType: actionType ?? 0 /* CALL */,
    data,
    tokenAddressOffset,
    tokenAmountOffset
  };
};
export {
  AMOUNT,
  CallType,
  FLEX,
  GLOBAL_ADDRESS_SERVER_URL,
  TOKEN_ADDRESSES,
  createCall,
  createGlobalAddress,
  getGlobalAddressFeeEstimates,
  getGlobalAddressInfo,
  getGlobalAddressStatus,
  getWrappedNativeAddress
};
//# sourceMappingURL=index.js.map